import { Injectable, NgZone, OnDestroy } from '@angular/core';
import type { NotificationCountInterface } from '@zaoblako/shared/modules/notification/dtos/informer/notification.count.dto';
import { NotificationService } from '@zaoblako/web/core/services/notification/notification.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UnreadCountStorageService implements OnDestroy {
  private readonly key = 'notification_unread_count';

  public constructor(private readonly notificationService: NotificationService, private readonly ngZone: NgZone) {
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('storage', this.handleStorageEvent.bind(this));
    });
    this.notificationService.unreadCount$.pipe(
      debounceTime(50),
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
    );
  }

  private handleStorageEvent(event: StorageEvent): void {
    if (event.key === this.key && event.newValue) {
      this.ngZone.run(() => {
        const newValue = JSON.parse(event.newValue);
        this.notificationService.unreadCount$.next(newValue);
      });
    }
  }

  public setParam(value: NotificationCountInterface): void {
    localStorage.setItem(this.key, JSON.stringify(value));
  }

  public ngOnDestroy(): void {
    window.removeEventListener('storage', this.handleStorageEvent.bind(this));
  }
}
